import { Loader, Typography } from "@commonlibs";
import clsx from "clsx";
import { config } from "common/config";
import { formatFiatAmount } from "features/wallet/utils";
import { useGetToken } from "features/token/hooks/useGetToken";
import { useFormatBalance } from "ui/wallet/components/display/Balance/hook/useFormatBalance";
import { PointsBalanceProps } from "../PointsBalance/PointsBalance";

export interface FiatBalanceProps extends Omit<PointsBalanceProps, "unitsPosition"> {}

function FiatBalance({ className, balance = "0", isLoading: isLoadingProp, options, thresholds, action, ...rest }: FiatBalanceProps) {
    const { data: token, isLoading } = useGetToken(config.organization.tokenAddress);
    const loading = isLoadingProp || isLoading || token?.conversionRate === undefined;

    const formmatedBalance = formatFiatAmount(
        balance,
        config.organization.decimals,
        token?.conversionRate ?? 0,
    );

    const formattedFiatBalance = useFormatBalance(formmatedBalance, {
        numberFormatOptions: options,
        action,
        thresholds,
    });
    return (
        <Typography className={clsx("fiat-balance", className)} {...rest}>
            {loading ? <Loader /> : `$${formattedFiatBalance} ${config.fiatCurrency}`}
        </Typography>
    );
}

export default FiatBalance;
